import GlobalPlayerContext from './context'
const GlobalPlayerConsumer = GlobalPlayerContext.Consumer;
export default GlobalPlayerConsumer;